import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'

const SELECT_SERVICE_LINE = gql`
  mutation updateFreelancerServiceLine($freelancerId: Int!, $serviceLine: ServiceLines!) {
    updateFreelancerServiceLine(freelancerId: $freelancerId, serviceLine: $serviceLine) {
      id
      serviceLine
    }
  }
`

export default () => useMutation(SELECT_SERVICE_LINE)
